import { f7 } from 'framework7-react';
import { getLoginTelForType } from './loginTel';
import { getAffiliateIdFromThemeId } from './shop';
import { paths } from '@/config/paths';
import { store } from '@/config/store';
import { affiliateId } from '@/consts/shop';

/**
 * @param token logged in user token
 * @param id logged in user id
 * @param type login type
 */
interface AutoLoginParams {
  token: string;
  id: string;
  type?: string;
}

export const autoLoginNativeHelper = ({ token, id, type }: AutoLoginParams) => {
  if (store.state.authInfo.isLogin && store.state.authInfo.token) {
    if (
      Number(id) !== store.state.authInfo.m_customer_id ||
      decodeURI(token) !== store.state.authInfo.token
    ) {
      throw new Error(
        'ログイン状態が変わりました。現在のアカウントから開き直してください',
      );
    }
    return;
  }
  if (token) {
    const affiliateIdFromThemeId = getAffiliateIdFromThemeId(
      store.state.themeId,
    );
    if (affiliateIdFromThemeId === affiliateId.DEFAULT) {
      store.dispatch('setIsLoggedInToMaikuru', {
        isLoggedInToMaikuru: true,
      });
    }
    store.dispatch('setAuthInfo', {
      authInfo: {
        m_customer_id: Number(id),
        token: decodeURI(token),
        isLogin: true,
      },
    });
    const loginTel = getLoginTelForType(type);
    store.dispatch('setLoginInfo', {
      loginInfo: { loginType: type, tel: loginTel },
    });
    f7.views.main.router.navigate(paths.home);
  } else {
    f7.views.main.router.navigate(paths.loginTutorial);
  }
};
